/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

export const googleMapsKey = 'AIzaSyAnWJSarkqgNTx5ocG3PjsFUKrCNCuAnaQ';
export const autoUpdate = true;
export const baiduMap = false;
export const i18nBackendLoadPath = '/locales/{{lng}}/{{ns}}.json';
export const baseURL = 'https://backend.dev.soundtalksweb.com';
export const reversedFullName = false;
export const apkDownloadUrl = null;
export const enableSubscription = false;
export const isChinaConfig = false;
export const allowedDownloadDomains = [
  'soundtalks-dev-s3-backend-batch-exports.s3.eu-west-1.amazonaws.com', // Batch exports
  'd1yfw06htk050d.cloudfront.net', // Audio snippets
];
